import { render } from "./IGg.vue?vue&type=template&id=1bd64dc3"
import script from "./IGg.vue?vue&type=script&lang=js"
export * from "./IGg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__